import React from 'react'
import { useQuestaoEditorDispatch, useQuestaoEditorSelector, questaoEditorActions } from '../../../stores/hooks'
import { Button, Icon } from '../../semantic-ui-antd-adapter'
import { QuestaoAlternativaModel } from '../../../models/QuestaoAlternativaModel'
import styled from '@emotion/styled'
import { ItemAlternativa } from './ItemAlternativa'

export const RelacionarItens = ({ questaoId }) => {
  const dispatch = useQuestaoEditorDispatch()
  const questao = useQuestaoEditorSelector((s) =>
    s[questaoId] ? s[questaoId].questao : { questoesAlternativas: [] }
  )
  const questoesAlternativas = questao.questoesAlternativas || []

  return (
    <div>
      <div>Conceitos:</div>
      <div>
        {questoesAlternativas.map((alternativa) => (
          <Alternativa
            key={alternativa.id}
            questaoAlternativa={alternativa}
            questaoId={questaoId}
          />
        ))}
      </div>
      <div style={{ textAlign: 'right' }}>
        <Style.AdicionarAlternativa onClick={() => dispatch(questaoEditorActions.addAlternativa({ questaoId }))}>
          <Icon name="plus circle" /> Adicionar novo conceito
        </Style.AdicionarAlternativa>
      </div>
    </div>
  )
}

const Alternativa = ({
  questaoId,
  questaoAlternativa,
}: {
  questaoId: string
  questaoAlternativa: QuestaoAlternativaModel
}) => {
  const dispatch = useQuestaoEditorDispatch()
  function handleUpdateConteudoAlternativa(conteudoAlternativa) {
    dispatch(questaoEditorActions.changeConteudoAlternativa({
      questaoId,
      conteudoAlternativa,
      alternativaId: questaoAlternativa.id,
    } as any))
  }
  function handleUpdateRespostaEsperada(respostaEsperada) {
    dispatch(questaoEditorActions.changeRespostaEsperada({
      questaoId,
      respostaEsperada,
      alternativaId: questaoAlternativa.id,
    }))
  }
  function handleDeleteAlternativa() {
    dispatch(questaoEditorActions.deleteAlternativaById({ questaoId, alternativaId: questaoAlternativa.id }))
  }
  return (
    <Style.ContainerConceito>
      <div>
        <ItemAlternativa
          item={questaoAlternativa.conteudoAlternativa}
          updateItem={handleUpdateConteudoAlternativa}
        />
      </div>
      <div>
        <ItemAlternativa
          item={questaoAlternativa.respostaEsperada}
          updateItem={handleUpdateRespostaEsperada}
        />
      </div>
      <div className="delete">
        <Button icon="trash" onClick={handleDeleteAlternativa} />
      </div>
    </Style.ContainerConceito>
  )
}

const Style = {
  ContainerConceito: styled('div')`
    display: flex;
    padding: 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-bottom: 12px;
    & > div {
      flex: 1;
      &:not(:first-child) {
        margin-left: 12px;
      }
      &.delete {
        flex: none;
        align-self: flex-end;
      }
    }
    &:not(:first-child) {
      border-top: 1px solid #ccc;
    }
  `,
  Img: styled('img')`
    max-width: 100%;
  `,
  AdicionarAlternativa: styled('div')`
    padding: 12px;
    cursor: pointer;
    border-radius: 4px;
    display: inline-block;
    &:hover {
      background: #f2f2f2;
    }
  `,
}
